import { useState, useEffect, useCallback, useRef } from 'react';

const DEFAULT_SECONDS = 120;

const useCountdown = (
  countdownSeconds = DEFAULT_SECONDS,
  hideEmailMessage = false
) => {
  const [countdown, setCountdown] = useState(countdownSeconds);
  const currentIntervalRef = useRef(null);
  const [timeFormatCountdown, setTimeFormatCountdown] = useState('0:00');
  const [countdownFinished, setCountdownFinished] = useState(false);

  useEffect(() => {
    return () => {
      clearInterval(currentIntervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      setCountdownFinished(true);
    } else {
      setCountdownFinished(false);
    }
  }, [countdown]);

  useEffect(() => {
    if (countdown <= 0) {
      clearInterval(currentIntervalRef.current);
      currentIntervalRef.current = null;
    }
  }, [countdown]);

  useEffect(() => {
    const minutes = Math.floor(countdown / 60);
    let seconds = countdown - minutes * 60;
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    setTimeFormatCountdown(`${minutes}:${seconds}`);

    if (`${minutes}:${seconds}` === '0:00' && !hideEmailMessage) {
      setTimeFormatCountdown('Reenviar correo');
    }
  }, [countdown]);

  const startCountdown = useCallback(
    (resetSeconds = countdownSeconds) => {
      clearInterval(currentIntervalRef.current);
      setCountdown(resetSeconds);
      const backward = c => {
        return c >= 1 ? c - 1 : c;
      };
      const interval = setInterval(() => {
        setCountdown(backward);
      }, 1000);
      currentIntervalRef.current = interval;
    },
    [countdownSeconds]
  );

  return {
    startCountdown,
    setCountdown,
    countdown,
    timeFormatCountdown,
    countdownFinished
  };
};

export default useCountdown;
